import { Component, EventEmitter, Output, input, ChangeDetectionStrategy } from '@angular/core'
import { IAnnouncementItem } from '@lla-platform/announcements/announcements-data-access'

@Component({
  selector: 'lla-announcement-list-item',
  templateUrl: './announcement-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AnnouncementListItemComponent {
  item = input.required<IAnnouncementItem>()
  selected = input(false)
  nextItemSelected = input(false)

  @Output() opened = new EventEmitter<void>()
}
